import styled, { css, keyframes } from "styled-components";
const ScaleShow = keyframes `
    0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
`;
const UnScaleShow = keyframes `
    0% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
`;
const OpacityShow = keyframes `
    0% {
		visibility: hidden;
		opacity: 0;
	}
	100% {
		visibility: visible;
		opacity: 1;
	}
`;
const UnOpacityShow = keyframes `
    0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
`;
export const Wrap = styled.div `
    position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 999;
	background: rgba(0, 0, 0, 0.5);
	color: #fff;
	visibility: hidden;
	opacity: 0;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	transition: visibility 0s 0s ease-in-out, opacity 0.25s 0s ease-in-out;

    ${(props) => {
    if (props.show) {
        return css `
						animation: ${OpacityShow} 0.25s 0s ease-in-out 1 normal forwards;
						pointer-events: auto;
					`;
    }
    return css `
					animation: ${UnOpacityShow} 0.25s 0s ease-in-out 1 normal forwards;
					pointer-events: none;
				`;
}};
`;
export const DialogMain = styled.div `
    transition: all 0.25s 0s ease-in-out;
	pointer-events: auto;
    ${(props) => {
    if (props.show) {
        return css `
					animation: ${ScaleShow} 0.25s 0s ease-in-out 1 normal forwards;
				`;
    }
    return css `
					animation: ${UnScaleShow} 0.25s 0s ease-in-out 1 normal forwards;
				`;
}};
`;
